export default {
  getAll: (...paramKeys) => {
    const params = new URLSearchParams(window.location.search)
    const vals = paramKeys.map(key => params.get(key))
    return vals
  },
  get: paramKey => {
    const params = new URLSearchParams(window.location.search)
    return params.get(paramKey)
  }
}
